import { render, staticRenderFns } from "./WarrantyReturnsPage.vue?vue&type=template&id=2d527bd3&scoped=true"
import script from "./WarrantyReturnsPage.vue?vue&type=script&lang=js"
export * from "./WarrantyReturnsPage.vue?vue&type=script&lang=js"
import style0 from "./WarrantyReturnsPage.vue?vue&type=style&index=0&id=2d527bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d527bd3",
  null
  
)

export default component.exports